import React, { useState, useEffect } from 'react';
import './surveillance.css';
import { FaEllipsisV } from "react-icons/fa";
import { FaFolder } from "react-icons/fa";
import { FaBed } from "react-icons/fa6";
import Select from 'react-select';
import api from '../../service/caller';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom'

function SurveillanceQuotidienne({ onNext, onBack, updatePatientDossier, patientId }) {
  const [vitals, setVitals] = useState({ bloodPressure: '', temperature: '', heartRate: '', respirationRate: '' });
  const [observations, setObservations] = useState('');
  const [entries, setEntries] = useState([]);
  const [UserData, setUserData] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setVitals(prev => ({ ...prev, [name]: value }));
    
    // Clear error for this field when user types
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  useEffect(() => {
    const fetchLoggedUserData = async () => {
      try {
        const response = await api.get('api/usersprofile');
        setUserData(response.data);
      } catch (error) {
        console.error("Failed to fetch user data", error);
      }
    };
    
    fetchLoggedUserData();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    
    // Blood pressure validation (format: 120/80)
    if (!vitals.bloodPressure) {
      newErrors.bloodPressure = 'Blood pressure is required';
    } else if (!/^\d{2,3}\/\d{2,3}$/.test(vitals.bloodPressure)) {
      newErrors.bloodPressure = 'Invalid format. Use format 120/80';
    }
    
    // Temperature validation (36-42°C)
    if (!vitals.temperature) {
      newErrors.temperature = 'Temperature is required';
    } 
    // else {
    //   const temp = parseFloat(vitals.temperature);
    //   if (isNaN(temp) || temp < 35 || temp > 42) {
    //     newErrors.temperature = 'Temperature must be between 35°C and 42°C';
    //   }
    // }
    
    // Heart rate validation (30-200 bpm)
    if (!vitals.heartRate) {
      newErrors.heartRate = 'Heart rate is required';
    } 
    // else {
    //   const hr = parseInt(vitals.heartRate);
    //   if (isNaN(hr) || hr < 30 || hr > 200) {
    //     newErrors.heartRate = 'Heart rate must be between 30 and 200 bpm';
    //   }
    // }
    
    // Respiration rate validation (8-30 breaths/min)
    if (!vitals.respirationRate) {
      newErrors.respirationRate = 'Respiration rate is required';
    } 
    // else {
    //   const rr = parseInt(vitals.respirationRate);
    //   if (isNaN(rr) || rr < 8 || rr > 60) {
    //     newErrors.respirationRate = 'Respiration rate must be between 8 and 60 breaths/min';
    //   }
    // }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const addEntry = async () => {
    setIsSubmitting(true);
    
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      // Création de la nouvelle entrée en incluant l'heure et la date
      const newEntry = {
          patientId: patientId.patientId._id,
          nurseId: UserData._id,
          vitalSigns: vitals,
          observations: observations,
      };

      await api.post(`api/treatment-plans/checkins`, newEntry);

      // Réinitialiser les champs
      setVitals({ bloodPressure: '', temperature: '', heartRate: '', respirationRate: '' });
      setObservations('');
      setErrors({});
      
      // Passer à l'écran suivant
      onNext(5);
    } catch (error) {
      console.error("Erreur lors de l'ajout de l'entrée:", error);
      setErrors(prev => ({ ...prev, submit: "Error saving data. Please try again." }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="vitals-monitor">
    <div className="vitals-card">
      <div className="vitals-card-header">
        <h1 className="vitals-title">Daily Monitoring</h1>
        <div className="vitals-pulse"></div>
      </div>
      
      <div className="vitals-form">
        <div className="vitals-input-wrapper">
          <input
            id="bloodPressure"
            type="text"
            name="bloodPressure"
            placeholder=" "
            value={vitals.bloodPressure}
            onChange={handleChange}
            className={errors.bloodPressure ? "vitals-input vitals-error" : "vitals-input"}
          />
          <label className="vitals-label">Blood Pressure (e.g., 120/80)</label>
          <div className="vitals-line"></div>
          {errors.bloodPressure && 
            <small className="vitals-error-text">{errors.bloodPressure}</small>
          }
        </div>
        
        <div className="vitals-input-wrapper">
          <input
            id="temperature"
            type="text"
            name="temperature"
            placeholder=" "
            value={vitals.temperature}
            onChange={handleChange}
            className={errors.temperature ? "vitals-input vitals-error" : "vitals-input"}
          />
          <label className="vitals-label">Temperature (°C)</label>
          <div className="vitals-line"></div>
          {errors.temperature && 
            <small className="vitals-error-text">{errors.temperature}</small>
          }
        </div>
        
        <div className="vitals-input-wrapper">
          <input
            id="heartRate"
            type="text"
            name="heartRate"
            placeholder=" "
            value={vitals.heartRate}
            onChange={handleChange}
            className={errors.heartRate ? "vitals-input vitals-error" : "vitals-input"}
          />
          <label className="vitals-label">Heart Rate (bpm)</label>
          <div className="vitals-line"></div>
          {errors.heartRate && 
            <small className="vitals-error-text">{errors.heartRate}</small>
          }
        </div>
        
        <div className="vitals-input-wrapper">
          <input
            id="respirationRate"
            type="text"
            name="respirationRate"
            placeholder=" "
            value={vitals.respirationRate}
            onChange={handleChange}
            className={errors.respirationRate ? "vitals-input vitals-error" : "vitals-input"}
          />
          <label className="vitals-label">Respiration Rate (breaths/min)</label>
          <div className="vitals-line"></div>
          {errors.respirationRate && 
            <small className="vitals-error-text">{errors.respirationRate}</small>
          }
        </div>
        
        <div className="vitals-textarea-wrapper">
          <textarea
            placeholder=" "
            value={observations}
            onChange={(e) => setObservations(e.target.value)}
            className="vitals-textarea"
          />
          <label className="vitals-textarea-label">Medical Observations</label>
        </div>
        
        {errors.submit && <div className="vitals-submit-error">{errors.submit}</div>}
      </div>
      
      <div className="vitals-actions">
        <button
          className="vitals-btn vitals-btn-primary"
          onClick={addEntry}
          disabled={isSubmitting || patientId.status !== "Active"}
        >
          <span className="vitals-btn-text">
            {isSubmitting ? "Saving..." : "View Complete Medical History"}
          </span>
          <span className="vitals-btn-icon">&#x2192;</span>
        </button>
        {onBack && 
          <button 
            className="vitals-btn vitals-btn-secondary" 
            onClick={() => onNext(1)} 
            disabled={isSubmitting}
          >
            <span className="vitals-btn-icon">&#x2190;</span>
            <span className="vitals-btn-text">Retour</span>
          </button>
        }
      </div>
    </div>
  </div>
  );
}

export default SurveillanceQuotidienne;